export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "confirm-modal-description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This action cannot be undone."])},
        "confirm-modal-title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Are you sure you want to proceed?"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Examples of dialogs"])}
      },
      "fr": {
        "confirm-modal-description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cette action ne peut être annulée."])},
        "confirm-modal-title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voulez-vous vraiment continuer?"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exemples de dialogues"])}
      }
    }
  })
}
